// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root[data-v-19e85b4f]{visibility:hidden;position:absolute;right:0;bottom:0}", ""]);
// Exports
module.exports = exports;
